import type { RouteObject } from "react-router-dom";
import { NotFound } from "../../components/not-found.components";
import LoginScreen from "../screens/auth/login.screen";
import NameFormScreen from "../screens/auth/name-form.screen";

export const authRouter: Array<RouteObject> = [
  {
    path: "login",
    element: <LoginScreen />,
  },
  { path: "complete-profile", element: <NameFormScreen /> },

  {
    path: "*",
    element: <NotFound />,
  },
];
